import { render } from "./AgentCalls.vue?vue&type=template&id=0cd7b6c8&scoped=true"
import script from "./AgentCalls.vue?vue&type=script&lang=js"
export * from "./AgentCalls.vue?vue&type=script&lang=js"

import "./AgentCalls.vue?vue&type=style&index=0&id=0cd7b6c8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd7b6c8"]])

export default __exports__